<template>
  <v-app>
    <v-main>
      <v-container fluid v-if="errorMessage">
        <v-alert border="top" colored-border type="info" elevation="2">
          {{errorMessage}}
        </v-alert>
      </v-container>
      <v-container fluid>
        <v-row no-gutters>
          <v-col>
            <VueLanguageSelect v-model="selection" />
          </v-col>
          <v-col class="col-auto">
            <v-btn color="primary" dense @click="send" :loading="loading">
              Send
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-textarea
              solo
              name="input-7-4"
              label="Text"
              v-model="text"
              dense
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="result">
        <v-simple-table class="output-table" fixed-header height="300px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Language</th>
                <th class="text-left">Text</th>
                <th class="text-left">Translation</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in result.intermediateResults"
                :key="item.language.code"
              >
                <td>{{ item.language.name }}</td>
                <td>{{ item.result }}</td>
                <td>{{ item.translatedResult }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import VueLanguageSelect from "./components/VueLanguageSelect";

export default {
  name: "App",

  components: {
    VueLanguageSelect,
  },

  data: () => ({
    text: "",
    selection: [],
    result: undefined,
    loading: false,
    errorMessage: undefined
  }),
  methods: {
    send() {
      this.errorMessage = undefined;

      if(this.selection.length <= 0) {
        this.errorMessage = "You must select at least one language!";
        return;
      }
      if(!this.text) {
        this.errorMessage = "Text may not be empty!";
        return;
      }


      this.loading = true;
      fetch("https://ki.hs-kl.de/stillepost/api/stille-post", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text: this.text,
          sourceLanguage: "de",
          model: "nmt",
          languages: this.selection,
          includeTranslatedIntermediateResult: true,
        }),
      })
        .then((response) => response.json())
        .then((result) => {
          result.intermediateResults = result.intermediateResults.reverse();
          this.result = result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.output-table tr:first-child td {
  background: #1976d2;
  color: #fff;
}
</style>